import React from 'react';
import PropTypes from 'prop-types';

const Button = React.forwardRef(
  ({ onClick, children, disabled, className = '', ...props }, ref) => {
    return (
      <button
        ref={ref}
        {...props}
        disabled={disabled}
        className={`${className} ${disabled ? 'cursor-not-allowed' : ''}`}
        onClick={e => {
          // Prevent handling button double click
          if (!disabled && e.detail === 1) {
            onClick(e);
          }
        }}
      >
        {children}
      </button>
    );
  },
);

Button.propTypes = {
  onClick: PropTypes.func,
};

export default Button;
